// extracted by mini-css-extract-plugin
export default {"cover":"DomainItem_cover__HnWgQ","item":"DomainItem_item__MKuXR","card":"DomainItem_card__xi6fS","avatar":"DomainItem_avatar__YpL8t"};